var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "indicatorDiv",
      staticClass: "color-indicator",
      attrs: { tabindex: _vm.tooltipText ? 0 : null },
      on: {
        mouseenter: _vm.onMouseEnter,
        mouseleave: _vm.onMouseLeave,
        focus: _vm.onMouseEnter,
        blur: _vm.onMouseLeave
      }
    },
    [
      _vm.indicatorValue
        ? _c(
            "div",
            {
              staticClass: "color-indicator__circle",
              attrs: { "data-bg": _vm.dataBg }
            },
            [
              _c(
                "span",
                {
                  staticClass: "color-indicator__value",
                  attrs: { "data-color": _vm.dataColor }
                },
                [_vm._v(" " + _vm._s(_vm.indicatorValue) + " ")]
              )
            ]
          )
        : _c(
            "div",
            {
              ref: "indicatorBgSquare",
              staticClass: "color-indicator__square",
              style: _vm.squareStyle,
              attrs: { "data-bg": _vm.dataBg }
            },
            [
              _c("i", {
                ref: "indicatorIcon",
                class: ["color-indicator__icon icon", _vm.iconClassName],
                style: _vm.iconStyle,
                attrs: { "data-color": _vm.dataColor }
              })
            ]
          ),
      _c(
        "Tooltip",
        {
          attrs: { visible: _vm.tooltipVisible, trackedRefName: "indicatorDiv" }
        },
        [_vm._v(" " + _vm._s(_vm.tooltipText) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }